/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function(){
  $('.Product__FeatureImage').addClass('Image--zoomOut');
  
$(".ColorSwatchList input[checked=checked]+label").parent().next().find("label").click()
  $(".ColorSwatchList input[checked=checked]+label").click() 
  if($('body').hasClass('has-product')){
    var swatches = $(".ColorSwatchList li").length;
    if(swatches > 15){
      $('.ColorSwatchList').parent().append('<div class="more-colors text-right"><a href="javascript:void(0)">+ More Colors</a></div>')
    }
    $(".ColorSwatchList li").each(function(i){
      if(i > 13){
        $(this).hide()
      }
    })
    $('.more-colors a').click(function(){
      $(this).parent().hide();
      $(".ColorSwatchList li").css('display','inline-block')
    })
  }
 
  $('.color-filter').click(function(){
    window.location.href=$(this).find('a').attr('href')
  })
  $('.custom-variant-filter').click(function(){
    if($(this).hasClass('is-active')){
		$('.main-product-grid').show();
    }
    else{
      $('.main-product-grid').hide();
      $('.'+$(this).attr('data-tag')).show();
     
       if($(".checkDiv").length==0){
            $('.Drawer__Close').click();
      }
      
     		
       
    }
  })
})